import Sleva from 'src/models/Sleva';

class CalculateOrderResponse {
    public clientId: number;
    public discount: Sleva;
    public price: number;
    public partialMenu: boolean;
}

export default CalculateOrderResponse;


// WEBPACK FOOTER //
// ./src/services/response/CalculateOrderResponse.tsx